/*!
 ** Unobtrusive validation support library for jQuery and jQuery Validate
 ** Copyright (C) Microsoft Corporation. All rights reserved.
 */

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global document: false, jQuery: false */

/*
 Completely modified by Greg Herrell to take the validation error scheme of MVC and also the extended remote validator functionality.
 However, the end result is much stripped down and not compatible with original scripts or framework.

 This is made to work with Jquery Validation Plugin in it's raw form using it's unobtrusive tags which are different than those by Microsoft
 */

(function ($) {
	var $jQval = $.validator,
		data_validation = "unobtrusiveValidation";

	function setValidationValues(options, ruleName, value) {
		options.rules[ruleName] = value;
		if (options.message) {
			options.messages[ruleName] = options.message;
		}
	}

	function splitAndTrim(value) {
		return value.replace(/^\s+|\s+$/g, "").split(/\s*,\s*/g);
	}

	function escapeAttributeValue(value) {
		// As mentioned on http://api.jquery.com/category/selectors/
		return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
	}

	function onError(error, inputElement) {  // 'this' is the form element
		var container = $(this).find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"),
			replaceAttrValue = container.attr("data-valmsg-replace"),
			replace = replaceAttrValue ? JSON.parse(replaceAttrValue) !== false : null;

		container.removeClass("field-validation-valid").addClass("field-validation-error");
		error.data("unobtrusiveContainer", container);

		if (replace) {
			container.empty();
			error.removeClass("input-validation-error").appendTo(container);
		} else {
			error.hide();
		}
	}

	function onErrors(event, validator) {  // 'this' is the form element
		var container = $(this).find("[data-valmsg-summary=true]"),
			list = container.find("ul");

		if (list && list.length && validator.errorList.length) {
			list.empty();
			container.addClass("validation-summary-errors").removeClass("validation-summary-valid");

			$.each(validator.errorList, function () {
				$("<li />").html(this.message).appendTo(list);
			});
		}

		$(this).triggerHandler("onerrors.validate", [this]);
	}

	function onSuccess(error) {  // 'this' is the form element
		var container = error.data("unobtrusiveContainer"),
			replaceAttrValue = container.attr("data-valmsg-replace"),
			replace = replaceAttrValue ? JSON.parse(replaceAttrValue) : null;

		if (container) {
			container.addClass("field-validation-valid").removeClass("field-validation-error");
			error.removeData("unobtrusiveContainer");

			if (replace) {
				container.empty();
			}
		}
	}

	function onReset(event) {  // 'this' is the form element
		var $form = $(this);
		$form.data("validator").resetForm();
		$form.find(".validation-summary-errors")
			.addClass("validation-summary-valid")
			.removeClass("validation-summary-errors");
		$form.find(".field-validation-error")
			.addClass("field-validation-valid")
			.removeClass("field-validation-error")
			.removeData("unobtrusiveContainer")
			.find(">*")  // If we were using valmsg-replace, get the underlying error
			.removeData("unobtrusiveContainer");
	}

	function validationInfo(form) {
		var $form = $(form),
			result = $form.data(data_validation),
			onResetProxy = $.proxy(onReset, form);

		if (!result) {
			result = {
				options: {  // options structure passed to jQuery Validate's validate() method
					errorClass: "input-validation-error",
					errorElement: "span",
					errorPlacement: $.proxy(onError, form),
					invalidHandler: $.proxy(onErrors, form),
					messages: {},
					rules: {},
					success: $.proxy(onSuccess, form)
				},
				attachValidation: function () {
					$form
						.off("reset." + data_validation, onResetProxy)
						.on("reset." + data_validation, onResetProxy)
						.validate(this.options);
				},
				validate: function () {  // a validation function that is called by unobtrusive Ajax
					$form.validate();
					return $form.valid();
				}
			};
			$form.data(data_validation, result);
		}

		return result;
	}

	$jQval.unobtrusive = {
		parse: function (selector) {
			/// <summary>
			/// wires up the change events for the validators to override jquery validate's default placement.
			/// Also extends the remote method to account for additional parameters
			/// </summary>
			/// <param name="selector" type="String">Any valid jQuery selector.</param>
			var $forms = $(selector)
				.parents("form")
				.addBack()
				.add($(selector).find("form"))
				.filter("form");

			$(selector).find(":input[data-rule-remote]").each(function () {
				$jQval.unobtrusive.extendRemote(this);
			});

			$forms.each(function () {
				var info = validationInfo(this);
				if (info) {
					info.attachValidation();
				}
			});
		},

		/*
		 hacked out of the original ParseElement functionality with adapters, etc...
		 I'm not impressed with my end-result.
		 */
		extendRemote: function (element) {
			var $element = $(element),
				form = $element.parents("form")[0],
				valInfo, rules, messages;

			if (!form) {  // Cannot do client-side validation without a form
				return;
			}

			valInfo = validationInfo(form);
			valInfo.options.rules[element.name] = rules = {};
			valInfo.options.messages[element.name] = messages = {};

			var message = $element.attr("data-msg-remote") || "";
			var paramValues = {};

			/*custom attributes for remote*/
			paramValues["url"] = $element.attr("data-rule-remote");
			paramValues["type"] = $element.attr("data-type-remote");
			paramValues["additionalfields"] = $element.attr("data-additionalfields-remote");

			var options = {
				element: element,
				form: form,
				message: message,
				params: paramValues,
				rules: rules,
				messages: messages
			};

			var value = {
				url: options.params.url,
				type: options.params.type || "GET",
				data: {}
			}

			$.each(splitAndTrim(options.params.additionalfields || options.element.name), function (i, fieldName) {
				value.data[fieldName] = function () {
					var field = $(options.form).find(":input[name='" + escapeAttributeValue(fieldName) + "']");
					var type = field.attr('type');

					if (type != undefined && type.toLowerCase() == "radio")
						return $(options.form).find(":input[name='" + escapeAttributeValue(fieldName) + "']:checked").val();
					else
						return $(options.form).find(":input[name='" + escapeAttributeValue(fieldName) + "']").val();
				};
			});

			setValidationValues(options, "remote", value);

			$.extend(rules, {"__dummy__": true});
		}
	};

	$jQval.addMethod("__dummy__", function (value, element, params) {
		return true;
	});

	$(function () {
		$jQval.unobtrusive.parse(document);
	});
}(jQuery));

jQuery.validator.addMethod("custom", function (value, element) {
	var valFunc = $(element).data('rule-custom');

	var fns = valFunc.split(",");

	var finalResult = true;

	for (var i = 0; i < fns.length; i++) {
		let vldName = fns[i];
		let names = vldName.split('.');
		let fn = null;

		if (names.length > 1) {
			fn = window[names[0]];
			for (let j = 1; j < names.length; j++) {
				let name = names[j];
				if (fn[name])
					fn = fn[name];
				else {
					fn = null;
					break;
				}
			}
		} else
			fn = window[vldName];

		var result = true;

		if (fn)
			result = fn(value, element);

		if (!result)
			finalResult = false;
	}

	return finalResult;
}, "validation failed.");

/* from the additional methods of jquery validation */
/**
 * Return true, if the value is a valid date, also making this formal check mm/dd/yyyy.
 *
 * altered from dateITA to account for USA dates
 *
 * @example jQuery.validator.methods.date("01/01/1900")
 * @result true
 *
 * @example jQuery.validator.methods.date("01/13/1990")
 * @result false
 *
 * @example jQuery.validator.methods.date("01.01.1900")
 * @result false
 *
 * @example <input name="pippo" class="{dateITA:true}" />
 * @desc Declares an optional input element whose value must be a valid date.
 *
 * @name jQuery.validator.methods.dateITA
 * @type Boolean
 * @cat Plugins/Validate/Methods
 */
jQuery.validator.addMethod("dateUSA", function (value, element) {
	var check = false;
	var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
	if (re.test(value)) {
		var adata = value.split('/');
		var mm = parseInt(adata[0], 10);
		var gg = parseInt(adata[1], 10);
		var aaaa = parseInt(adata[2], 10);
		var xdata = new Date(aaaa, mm - 1, gg);
		if ((xdata.getFullYear() === aaaa) && (xdata.getMonth() === mm - 1) && (xdata.getDate() === gg)) {
			check = true;
		} else {
			check = false;
		}
	} else {
		check = false;
	}
	return this.optional(element) || check;
}, "Please enter a correct date");

/**
 * Return true if the field value matches the given format RegExp
 *
 * @example jQuery.validator.methods.pattern("AR1004",element,/^AR\d{4}$/)
 * @result true
 *
 * @example jQuery.validator.methods.pattern("BR1004",element,/^AR\d{4}$/)
 * @result false
 *
 * @name jQuery.validator.methods.pattern
 * @type Boolean
 * @cat Plugins/Validate/Methods
 */
jQuery.validator.addMethod("pattern", function (value, element, param) {
	if (this.optional(element)) {
		return true;
	}

	if (typeof param === 'string') {
		var test = /^\/{1}.+\/{1}[a-zA-Z]?$/;

		if (test.test(param)) {
			param = param.replace(/^\//, "");

			var flags = param.match(/\/{1}[a-zA-Z]?$/);

			if (flags.length > 0) {
				flags = flags[0].replace("/", "");
				param = param.replace(/\/{1}[a-zA-Z]?$/, "");
			} else
				flags = "";

			param = new RegExp(param, flags);
		} else
			param = new RegExp('^(?:' + param + ')$');
	}
	return param.test(value);
}, "Invalid format.");

jQuery.validator.addMethod("maxfilesize", function (value, element, param) {
	if (this.optional(element)) {
		return true;
	}

	if (element.files) {
		var bytes = parseInt(param * 1000);

		if (!isNaN(bytes)) {
			var size = element.files[0].size;
			return size <= bytes;
		} else
			return true;
	}
	if (typeof param === 'string') {
		param = new RegExp('^(?:' + param + ')$');
	}
	return param.test(value);
}, "File is too large.");

//--fix maxlength by overriding it
jQuery.validator.addMethod("maxlength", function (value, element, len) {
	if (value != "") {
		var replaced = value.replace(/(\n)/g, '##');

		return replaced.length <= len;
	} else {
		return true;
	}
});

jQuery.validator.addMethod("intval", function (value, element) {
	return this.optional(element) || /^(0|[1-9]\d*)$/.test(value);
});

/*adds additional events to jquery validate*/
(function ($) {
	$.fn.addEventsToJqueryValidate = function () {
		return $(this).each(function () {
			var form = $(this);

			// Grab this element's validator object (if it has one)
			var validator = form.data('validator');

			// Only run this code if there's a validator associated with this element
			if (!validator)
				return;

			// Only add these triggers to each element once
			if (form.data('addEventsToJqueryValidate'))
				return;
			else
				form.data('addEventsToJqueryValidate', true);

			/*add on format event*/
			validator.settings.onfocusout = function (el) {
				/*duplicating original code here*/
				if (!validator.checkable(el) && (el.name in validator.submitted || !validator.optional(el))) {
					form.trigger('beforeonfocusoutvalidate', el);
					validator.element($(el));
				}
			};
		});
	};
})(jQuery);
